import Swiper from 'swiper';

export default function initTestimonials(): void {
  Alpine.data('testimonials', () => ({
    youtubePlayer: null as YT.Player | null,
    videoHolder: null as HTMLElement | null,
    swiper: null as Swiper | null,

    init() {
      this.swiper = new Swiper(this.$root, {
        loop: true,
        slidesPerView: 1,
        on: {
          slideChange: () => {
            if (this.youtubePlayer) {
              this.youtubePlayer.stopVideo();
              this.youtubePlayer.destroy();
              const image = this.videoHolder
                ?.previousElementSibling
                ?.getElementsByTagName('img')[0];
              if (image) {
                image.classList.remove('opacity-0', 'hidden');
              }
              this.videoHolder?.classList.remove('opacity-100');
              this.videoHolder?.classList.add('pointer-events-none');
              const playButton = this.videoHolder?.nextElementSibling;
              playButton?.classList.remove('hidden');
              playButton?.nextElementSibling?.classList.remove('opacity-100');
              this.youtubePlayer = null;
            }
          },
        },
      });
    },

    play() {
      this.videoHolder = this.$el.previousElementSibling as HTMLElement | null;
      const video = this.videoHolder?.querySelector('.video');
      if (
        this.videoHolder instanceof HTMLElement
        && video && video instanceof HTMLDivElement
        && video.dataset.provider === 'YouTube'
      ) {
        if (
          document.querySelector('script[src="https://www.youtube.com/iframe_api"]') === null
        ) {
          const tag = document.createElement('script');
          tag.src = 'https://www.youtube.com/iframe_api';
          const firstScriptTag = document.getElementsByTagName('script')[0];
          firstScriptTag.parentNode?.insertBefore(tag, firstScriptTag);

          // @ts-expect-error: onYouTubeIframeAPIReady is not globally defined
          window.onYouTubeIframeAPIReady = () => {
            if (this.videoHolder) {
              this.createPlayer(this.videoHolder, video);
            }
          };
        } else {
          this.createPlayer(this.videoHolder, video);
        }
      }
    },

    stop() {
      if (this.youtubePlayer) {
        this.youtubePlayer.stopVideo();
        this.youtubePlayer.destroy();
        const image = this.videoHolder?.previousElementSibling?.getElementsByTagName('img')[0];
        if (image) {
          image.classList.remove('opacity-0', 'hidden');
        }
        this.videoHolder?.classList.remove('opacity-100');
        this.videoHolder?.classList.add('pointer-events-none');
        const playButton = this.videoHolder?.nextElementSibling;
        playButton?.classList.remove('hidden');
        playButton?.nextElementSibling?.classList.remove('opacity-100');
        this.youtubePlayer = null;
      }
    },

    prev() {
      if (this.swiper) {
        this.swiper.slidePrev();
      }
    },

    next() {
      if (this.swiper) {
        this.swiper.slideNext();
      }
    },

    createPlayer(videoHolder: HTMLElement, video: HTMLElement) {
      this.youtubePlayer = new YT.Player(video, {
        videoId: video.dataset.videoId,
        width: videoHolder?.dataset.videoWidth ?? '100%',
        height: videoHolder?.dataset.videoHeight ?? '100%',
        playerVars: {
          autoplay: 1,
          controls: 1,
          mute: 0,
          rel: 0,
          loop: 0,
        },
        events: {
          onReady: (event: { target: YT.Player }) => {
            event.target.playVideo();
            const image = videoHolder?.previousElementSibling?.getElementsByTagName('img')[0];
            if (image) {
              image.classList.add('opacity-0', 'hidden');
            }
            videoHolder?.classList.add('opacity-100');
            videoHolder?.classList.remove('pointer-events-none');
            this.$el.classList.add('hidden');
            this.$el.nextElementSibling?.classList.add('opacity-100');
            this.youtubePlayer = event.target;
          },
        },
      });
    },
  }));
}
